import { render, staticRenderFns } from "./ReceiptNote.vue?vue&type=template&id=7cbfc0d6&scoped=true&"
import script from "./ReceiptNote.vue?vue&type=script&lang=js&"
export * from "./ReceiptNote.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptNote.vue?vue&type=style&index=0&id=7cbfc0d6&prod&lang=css&"
import style1 from "./ReceiptNote.vue?vue&type=style&index=1&id=7cbfc0d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbfc0d6",
  null
  
)

export default component.exports